var fn = function( obj ){
var __t,__p='';
__p+=''+
( require( "@/webgl/glsl/includes/glsl-compat.vert" )() )+
'\n\n\nIN vec4 aPosition;\nIN vec3 aTexCoord;\nIN vec3 aRand;\n\nOUT vec2 vTexCoord;\nOUT vec2 vTexCoordGrad;\n\nuniform mat4 uMVP;\nuniform vec3 uOffset;\n\nvoid main(void) {\n\n  vec3 pos = vec3(aPosition.xy, 0.0);\n  pos.xy += aRand.xy * (1.0 - uOffset.z);\n  pos.z += aRand.z * (1.0 - uOffset.z) * 0.4;\n\n  gl_Position = uMVP * vec4(pos, 1.0);\n\n  vTexCoordGrad = aPosition.xy * 0.2;\n  vTexCoordGrad += uOffset.xy;\n  vTexCoord = aTexCoord.xy;\n  \n}';
return __p;
};
fn.toString=fn;
module.exports = fn;